import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

var language = window.navigator.userLanguage || window.navigator.language;
var selection = "";

if (language === "id") {
  selection = require("../languages/id.lang");
} else {
  selection = require("../languages/en-US.lang");
}

const messages = {
  locale: {
    message: selection
  }
};

const i18n = new VueI18n({
  locale: "locale",
  messages
});

export default i18n;
